import {USER_INFO, CLEAR_USER_INFO, SWITCH_USER_INFO} from "../constants/actionTypes";
import {getVisibleObj, isObjEmpty} from "../../utils/common";

/*teacher: {
    teacherId: 0,
        userId: 0,
        openid: '',
        userPhone: '',
        schoolId: 0,
        schoolName: '',
        teacherNumber: '',
        teacherName: '',
        teacherPhoto: '',
        teacherAddress: '',
        teacherEntry: '',
        teacherBirthday: '',
        teacherSex: 0,//1：男，2：女
        albums: [],
        videos: []
},
parent: {
    parentId: 0,
        userId: 0,
        userPhone: '',
        openid: '',
        schoolId: 0,
        schoolName: '',
        parentsName: '',
        parentsBirthday: '',
        parentsSex: 0,
        parentsPhoto: '',
        parentsAddress: '',
        students:'',
        student:{
            albums: [],
            videos: []
        }
}*/

const initListState = {
    /*userId: 10003,
    school: '',
    schoolId: 1,
    userName: '',
    students: [],
    stuName: '',
    stuId: '',
    student: '',
    userOpenid: 'o8lZ9uJjHXWw2oaHBgSXXnP9pwpU',
    userPhone: '18130506086',
    userRole: 0,
    userRoles: [],
    accessToken: '17_2JV4JY47Ht5gTNCVHPQ3ya6ov9GPmtz_0JACss95_KdxnCVOWhrkmcLqBb27KmnEsYtLaWHxAT_bV_K44hRKD9A1yFib9IFYSkAdrVGtY-A',
    userAvatar: '',
    userSex: 0,
    token:''*/

    appId: '',
    userOpenid: '',
    userRole: 0,
    userAvatar: '',
    teacher: '',
    parent: '',
    user: {
        student: {}
    },
    token:''
}

const redUserInfo = (state = initListState, action) => {
    if (action === undefined) {
        return state
    }
    switch (action.type) {
        case USER_INFO:
            return {
                ...state,
                ...action
            }
        case CLEAR_USER_INFO:
            const appId = state.appId;
            return {
                ...initListState,
                appId:appId
            }
        case SWITCH_USER_INFO:
            const userRole = action.userRole

            let currentUser = {}
            if (userRole === 1) {
                currentUser = {
                    userFunId: state.parent.parentId,
                    userId: state.parent.userId,
                    schoolId: state.parent.schoolId,
                    schoolName: state.parent.schoolName,
                    userName: state.parent.parentsName,
                    userOpenid: state.parent.openid,
                    userPhone: state.parent.userPhone,
                    userAvatar: state.parent.parentsPhoto,
                    userSex: state.parent.parentsSex,
                    students: state.parent.students,
                    student: state.parent.student,
                    albums: isObjEmpty(state.parent.student) ? [] : state.parent.student.picAlbum,
                    videos: isObjEmpty(state.parent.student) ? [] : state.parent.student.videoAlbum
                }
            } else if (userRole === 2) {
                currentUser = {
                    userFunId: state.teacher.teacherId,
                    userId: state.teacher.userId,
                    schoolId: state.teacher.schoolId,
                    schoolName: state.teacher.schoolName,
                    userName: state.teacher.teacherName,
                    userOpenid: state.teacher.openid,
                    userPhone: state.teacher.userPhone,
                    userAvatar: state.teacher.teacherPhoto,
                    userSex: state.teacher.teacherSex,
                    students: [],
                    student: '',
                    albums: state.teacher.albums,
                    videos: state.teacher.videos
                }
            }
            return {
                ...state,
                userRole: userRole,
                user: currentUser
            }
        default:
            return state
    }

}

export default redUserInfo